import { render, staticRenderFns } from "./TabellaCustomAdapter.vue?vue&type=template&id=4148bc27&scoped=true&"
import script from "./TabellaCustomAdapter.vue?vue&type=script&lang=js&"
export * from "./TabellaCustomAdapter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4148bc27",
  null
  
)

export default component.exports